/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ResponseWebSearchCallSearchingEvent = {
  type: "response.web_search_call.searching";
  sequenceNumber: number;
  itemId: string;
  outputIndex: number;
};

/** @internal */
export const ResponseWebSearchCallSearchingEvent$inboundSchema: z.ZodType<
  ResponseWebSearchCallSearchingEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("response.web_search_call.searching"),
  sequence_number: z.number().int(),
  item_id: z.string(),
  output_index: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "sequence_number": "sequenceNumber",
    "item_id": "itemId",
    "output_index": "outputIndex",
  });
});
/** @internal */
export type ResponseWebSearchCallSearchingEvent$Outbound = {
  type: "response.web_search_call.searching";
  sequence_number: number;
  item_id: string;
  output_index: number;
};

/** @internal */
export const ResponseWebSearchCallSearchingEvent$outboundSchema: z.ZodType<
  ResponseWebSearchCallSearchingEvent$Outbound,
  z.ZodTypeDef,
  ResponseWebSearchCallSearchingEvent
> = z.object({
  type: z.literal("response.web_search_call.searching"),
  sequenceNumber: z.number().int(),
  itemId: z.string(),
  outputIndex: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    sequenceNumber: "sequence_number",
    itemId: "item_id",
    outputIndex: "output_index",
  });
});

export function responseWebSearchCallSearchingEventToJSON(
  responseWebSearchCallSearchingEvent: ResponseWebSearchCallSearchingEvent,
): string {
  return JSON.stringify(
    ResponseWebSearchCallSearchingEvent$outboundSchema.parse(
      responseWebSearchCallSearchingEvent,
    ),
  );
}
export function responseWebSearchCallSearchingEventFromJSON(
  jsonString: string,
): SafeParseResult<ResponseWebSearchCallSearchingEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ResponseWebSearchCallSearchingEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ResponseWebSearchCallSearchingEvent' from JSON`,
  );
}
